import { computed } from 'vue'
import { useStore } from 'vuex'
import { useOverlaysStore } from '@/stores/overlays.js'

// Helper composable built on top of the overlays store for opening modals.
export function useModals () {
  const { openModal, closeModal } = useOverlaysStore()
  const store = useStore()

  const isAuthenticated = computed(() => store.state.client.isAuthenticated)

  // Helper function to create a simple pair of open/close methods for a modal.
  function createModalMethods(name, { context = null, options = {} } = {}) {
    return [
      (additionalContext = null) => openModal({
        name,
        context: {
          ...context,
          ...additionalContext
        },
        options
      }),
      () => closeModal(name)
    ]
  }

  function openCreateCollectionModal () {
    openModal({ name: 'create-collection' })
  }

  function openAddToCollectionModal (styleColorId) {
    if (isAuthenticated.value) {
      openModal({
        name: 'add-to-collection',
        context: { styleColorId }
      })
    } else {
      openClosetRatingInfoModal('collect')
    }
  }

  function openClosetRatingInfoModal (action) {
    openModal({
      name: 'closet-rating-info',
      context: { action }
    })
  }
  function openDeleteCollectionModal (collectionId) {
    openModal({
      name: 'delete-collection',
      context: { collectionId: collectionId }
    })
  }
  function openShareModal (shareContext) {
    openModal({
      name: 'share-style-color-set-page',
      context: { styleColorSetPageModal: shareContext }
    })
  }
  function openReferralQRCodeModal () {
    openModal({
      name: 'referral-qr-code'
    })
  }
  function openRejoinModal () {
    openModal({
      name: 'rejoin'
    })
  }
  function closeRejoinModal () {
    closeModal('rejoin')
  }

  const [openUnlimitedIntroModal, closeUnlimitedIntroModal] = createModalMethods('unlimited-intro', {
    options: {
      aboveIntercom: true
    }
  })

  const [openHowToSwapModal, closeHowToSwapModal] = createModalMethods('how-to-swap', {
    options: {
      aboveIntercom: true
    }
  })

  const [openUnlimitedTrialModal, closeUnlimitedTrialModal] = createModalMethods('unlimited-trial', {
    options: {
      aboveIntercom: true
    }
  })

  const [openBuyItemModal, closeBuyItemModal] = createModalMethods('buy-item')

  const [openOutfitBuilderModal, closeOutfitBuilderModal] = createModalMethods('outfit-builder')

  return {
    openCreateCollectionModal,
    openAddToCollectionModal,
    openClosetRatingInfoModal,
    openDeleteCollectionModal,
    openShareModal,
    openReferralQRCodeModal,
    openRejoinModal,
    closeRejoinModal,
    openUnlimitedIntroModal,
    closeUnlimitedIntroModal,
    openHowToSwapModal,
    closeHowToSwapModal,
    openUnlimitedTrialModal,
    closeUnlimitedTrialModal,
    openBuyItemModal,
    closeBuyItemModal,
    openOutfitBuilderModal,
    closeOutfitBuilderModal
  }
}
export default useModals
